var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({staticClass:"form-input-text",class:{ 'form-field-error': _vm.vee ? _vm.vee.classes.failed : false }},'input',_vm.$props,false),Object.assign({}, _vm.$listeners,
    {input: function (event) { return _vm.$emit('input', event.target.value); }})))}
var staticRenderFns = []

export { render, staticRenderFns }